"use client";

import { useState } from "react";
import LiteYouTubeEmbed from "react-lite-youtube-embed";

export default function YoutubeEmbed({
  id,
  title,
  onPlayingChange,
  thumbnail,
  imageAlt,
}: {
  id: string;
  title: string;
  onPlayingChange?: (isPlaying: boolean) => void;
  thumbnail?: string;
  imageAlt?: string;
}) {
  const [isPlaying, setIsPlaying] = useState(false);

  // Handle click on the video thumbnail
  const handleActivation = () => {
    setIsPlaying(true);
    onPlayingChange?.(true);
  };

  return (
    <div className="relative" role="region" aria-label={imageAlt || title}>
      <LiteYouTubeEmbed
        id={id}
        title={title}
        activatedClass="lyt-activated"
        iframeClass="w-full aspect-video"
        playerClass="lty-playbtn"
        wrapperClass="yt-lite"
        poster="maxresdefault"
        noCookie={true}
        playlist={false}
        onIframeAdded={handleActivation}
        //if thumbnail is not available, don't add it
        {...(thumbnail && { thumbnail })}
      />

      <noscript>
        <iframe
          width="1280"
          height="720"
          src={`https://www.youtube.com/embed/${id}`}
          title={imageAlt || title}
          allowFullScreen
          loading="lazy"
          style={{ borderRadius: "8px", width: "100%", aspectRatio: "16/9" }}
        />
      </noscript>
    </div>
  );
}
